import { useContext } from 'react';
import { IntakeFormContext } from './IntakeFormContext';

export function useIntakeForm() {
  const context = useContext(IntakeFormContext);

  if (context === undefined) {
    throw new Error('useIntakeForm must be used within a IntakeFormProvider');
  }

  return context;
}
